import React from "react";
import { BarChart } from "@mui/x-charts";
import { TermAggregation } from "#next/components/catalog/base/shared";

export const RankedBarChart = ({
  label,
  aggregation,
}: {
  label: string;
  aggregation: TermAggregation | null;
}) => {
  if (!aggregation || !aggregation.buckets) return <></>;

  const buckets = aggregation?.buckets;

  return (
    <BarChart
      width={350}
      height={250}
      series={[
        {
          data: buckets.map((item) => item.doc_count),
          label: label,
          id: label.toLowerCase(),
        },
      ]}
      xAxis={[
        {
          data: buckets.map((item) => item.key),
          scaleType: "band",
        },
      ]}
    />
  );
};
